import { missions } from "@/mocks/homeData";
import { useScrollReveal, useStaggerReveal } from "@/hooks/useScrollReveal";
import Icon from "@/components/feature/Icon";

export default function MissionSection() {
  const { ref: headerRef, style: headerStyle } = useScrollReveal({ delay: 0 });
  const { containerRef, getItemStyle } = useStaggerReveal(missions.length, 120);

  return (
    <section className="py-24 md:py-32 bg-white">
      <div className="px-6 md:px-10 lg:px-16">
        {/* Section header */}
        <div ref={headerRef} style={headerStyle} className="max-w-3xl mb-16 md:mb-20">
          <p className="text-sm font-medium tracking-[0.2em] text-navy-700 uppercase mb-4">
            Core Missions
          </p>
          <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl font-semibold text-navy-950 leading-tight">
            從產業交流到生態系建構
            <br />
            <span className="text-silver-500">TAIAA 全方位推動 AI 發展</span>
          </h2>
        </div>

        {/* Missions (text cards, no images) */}
        <div ref={containerRef} className="space-y-6 md:space-y-0 md:grid md:grid-cols-3 md:gap-8">
          {missions.map((mission, index) => (
            <div
              key={mission.id}
              style={getItemStyle(index)}
              className="group relative bg-white rounded-3xl overflow-hidden border border-silver-200 hover:border-navy-200 transition-all duration-500 hover:shadow-xl"
            >
              {/* Content */}
              <div className="p-6 md:p-8">
                <div className="flex items-center justify-between mb-6">
                  <div className="w-12 h-12 rounded-xl bg-navy-950 flex items-center justify-center">
                    <Icon className={`${mission.icon} text-xl text-white`} />
                  </div>
                  <span className="text-4xl font-bold text-silver-200 font-serif">
                    0{index + 1}
                  </span>
                </div>
                <h3 className="text-xl md:text-2xl font-semibold text-navy-950 mb-4">
                  {mission.title}
                </h3>
                <p className="text-silver-500 text-sm md:text-base leading-relaxed">
                  {mission.description}
                </p>

                {/* Bottom line accent */}
                <div className="mt-6 h-[2px] bg-silver-100 rounded-full overflow-hidden">
                  <div className="h-full bg-navy-950 w-0 group-hover:w-full transition-all duration-500" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}